import React from 'react';
import SpinnerSvg from './images/spinner.svg';
import './globalLoader.module.scss';

export const GlobalLoader = () => (
  <div id="global-loader" styleName="loader-overlay">
    <img styleName="spinner" src={SpinnerSvg} />
  </div>
);
